"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MicrophoneDisabledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M6,7 L6,8.5 C6,10.4329966 7.56700338,12 9.5,12 C9.90120918,12 10.2866512,11.9324929 10.6455871,11.8082177 L11.1933235,12.6705346 C10.8183198,12.8229462 10.4181201,12.9262481 10.0007074,12.9724574 L10,14 L12,14 L12,15 L7,15 L7,14 L9,14 L9.00029704,12.9725684 C6.7501788,12.7239814 5,10.8163788 5,8.5 L5,7 L6,7 Z M6.85946839,2.15233734 L6.91602515,2.2226499 L13.9160251,13.2226499 C14.0692014,13.4524142 14.0071144,13.7628489 13.7773501,13.9160251 C13.5731151,14.0521818 13.3051406,14.018254 13.1405316,13.8476627 L13.0839749,13.7773501 L6.08397485,2.7773501 C5.93079862,2.54758575 5.99288556,2.23715108 6.2226499,2.08397485 C6.42688487,1.9478182 6.69485937,1.98174603 6.85946839,2.15233734 Z M7,6.08 L8,7.652 L8,8.5 C8,9.32641067 8.66830753,9.99672975 9.49395343,9.99998807 L10.086609,10.9307947 C9.89846149,10.9760357 9.70202932,11 9.5,11 C8.11928813,11 7,9.88071187 7,8.5 L7,6.08 Z M14,7 L14,8.5 C14,9.27511126 13.8040292,10.0044511 13.4589319,10.6411752 L12.8144356,9.62746709 C12.9150916,9.33147758 12.9772127,9.01767442 12.9948211,8.6920352 L13,8.5 L13,7 L14,7 Z M9.5,3 C10.8807119,3 12,4.11928813 12,5.5 L12,8.349 L11,6.778 L11,5.5 C11,4.67157288 10.3284271,4 9.5,4 C9.4135975,4 9.32890125,4.00730528 9.2464952,4.02133189 L8.6825062,3.13671647 C8.93866657,3.04812128 9.21371362,3 9.5,3 Z" })));
};
MicrophoneDisabledSmall.displayName = 'MicrophoneDisabledSmall';
exports.default = MicrophoneDisabledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MicrophoneDisabledSmall.js.map